import { memo, useCallback } from 'react';

import { TASK_ACTIONS } from '../../constants/tasks.js';
import { useConciergeHandoff } from '../../hooks/useConciergeHandoff.js';
import TaskCard from './TaskCard.jsx';

/**
 * A task whose action goes to the Concierge — Review draft, Answer, Reply
 * (CT-5722 over the CT-5721 seam). It hands off HERE, through
 * `useConciergeHandoff`: the hand-off follows the shell chat, which changes
 * with every streamed message, so only these rows re-render with it — never the
 * Tasks tab or the rest of its list (same rule as `NextBestActionActionButton`).
 * While the shell cannot open the Concierge the action is disabled: the flow is
 * never faked.
 *
 * @param {object} props
 * @param {object} props.task
 * @param {{ type: string, id: string, title: string|null }} props.entity — the record the Concierge is about.
 * @param {boolean} [props.busy]
 * @param {(task: object, mutation: string) => void} props.onMenu
 */
const TaskConciergeCard = memo(function TaskConciergeCard({ task, entity, busy = false, onMenu }) {
  const { available, openConcierge } = useConciergeHandoff();
  const intent = TASK_ACTIONS[task.action?.type]?.intent;

  const handleAction = useCallback(
    () =>
      openConcierge({
        intent,
        entity,
        itemId: task.id,
        draftId: task.action?.ref ?? null,
      }),
    [openConcierge, intent, entity, task.id, task.action?.ref],
  );

  return (
    <TaskCard
      task={task}
      actionState={available ? 'enabled' : 'disabled'}
      busy={busy}
      onAction={handleAction}
      onMenu={onMenu}
    />
  );
});

export default TaskConciergeCard;
